

/* ============ GALLERY — white grid + category filter ============ */
(function(){
  const GAL = window.__GALLERY__;
  const grid = document.getElementById('gGrid'), bar = document.getElementById('gFilters'), more = document.getElementById('gMore');
  if(!grid || !GAL) return;
  /* category: the Shopify "category" field when filled in, otherwise read from the words */
  const RULES = [
    ['Knives', /knife|knives|sabre|saber|blade|santoku|cleaver|machete|axe/],
    ['Drinkware', /bottle|tumbler|yeti|flask|mug|cup|glass|drinkware|stanley/],
    ['Parts & tools', /part|tool|handcuff|stethoscope|bike|gear|lever|industrial|serial|wrench|plier|medical|firearm|shovel|hammer|campagnolo/],
    ['Plates & awards', /plate|award|plaque|sign|badge|trophy|tag|nameplate/],
    ['Gifts', /zippo|lighter|wedding|gift|card|cowbell|chopstick|cooler|watch|branding|pen|keychain|key chain|jewel|pendant|ring|watch|leather|spoon|corkscrew|opener/]
  ];
  GAL.forEach(it=>{
    if(it.cat && String(it.cat).trim()){ it.cat=String(it.cat).trim(); return; }
    /* the name decides first; material, then photo text, only when the name says nothing */
    let r=null;
    for(const w of [it.name, it.mat, it.alt]){ const t=String(w||'').toLowerCase(); r=RULES.find(r=>r[1].test(t)); if(r) break; }
    it.cat=r?r[0]:'Other';
  });
  const cats=['All'].concat(RULES.map(r=>r[0]).filter(c=>GAL.some(it=>it.cat===c)))
    .concat(GAL.some(it=>!RULES.some(r=>r[0]===it.cat)) ? [...new Set(GAL.filter(it=>!RULES.some(r=>r[0]===it.cat)&&it.cat!=='Other').map(it=>it.cat))] : []);
  const FIRST=12;
  let cat='All', all=false, view=[];
  function draw(){
    const list=GAL.map((it,i)=>i).filter(i=>cat==='All'||GAL[i].cat===cat);
    const shown=(cat==='All'&&!all)?list.slice(0,FIRST):list;
    view=list;
    grid.textContent='';
    shown.forEach(i=>{
      const it=GAL[i], b=document.createElement('button');
      b.type='button'; b.className='gtile';
      b.setAttribute('aria-label', 'Open '+it.name);
      const img=document.createElement('img');
      img.src=it.src; img.alt=it.alt||it.name; img.loading='lazy'; img.decoding='async'; img.width=300; img.height=300;
      b.appendChild(img);
      b.addEventListener('click',()=>openLB(i));
      grid.appendChild(b);
    });
    more.hidden = shown.length>=list.length;
    more.textContent='Show all '+list.length+' pieces';
    if(bar) bar.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed', x.dataset.cat===cat?'true':'false'));
  }
  if(bar && cats.length>2) cats.forEach(c=>{
    const b=document.createElement('button'); b.type='button'; b.dataset.cat=c; b.textContent=c;
    b.addEventListener('click',()=>{ cat=c; all=false; draw(); });
    bar.appendChild(b);
  });
  if(more) more.addEventListener('click',()=>{ all=true; draw(); });
  draw();
  let sel=-1;

  // lightbox — full quality
  const lb=document.getElementById('lb'), lbMedia=document.getElementById('lbMedia'),
        lbName=document.getElementById('lbName'), lbDesc=document.getElementById('lbDesc'),
        lbCount=document.getElementById('lbCount');
  let lbLast=null, lbAt=-1;
  function openLB(which){
    const i = typeof which==='number' ? which : GAL.indexOf(which);
    const it = GAL[i]; if(!it) return;
    lbAt=i; sel=i;
    if(!lb.classList.contains('open')) lbLast=document.activeElement;
    lbMedia.innerHTML='<img src="'+it.full+'" alt="'+it.alt+'" loading="lazy" decoding="async">';
    lbName.textContent=it.name;
    const desc=(it.mat&&it.mat.trim()&&it.mat.trim()!==it.name)?it.mat.trim():(it.alt&&it.alt.trim()!==it.name?it.alt.trim():'');
    lbDesc.textContent=desc; lbDesc.style.display=desc?'':'none';
    const at=view.indexOf(i);
    lbCount.textContent=(at>-1?at+1:i+1)+' / '+(at>-1?view.length:GAL.length);
    lb.classList.add('open'); document.body.style.overflow='hidden';
    document.getElementById('lbClose').focus();
  }
  /* the hint should name the gesture the visitor actually has */
  (function(){
    const h=document.querySelector('.lb-hint');
    if(h && matchMedia('(hover:none)').matches) h.textContent='Swipe to move through the work';
  })();
  /* once a piece is open, arrows and swipes move to the next one */
  function lbGo(n){
    if(lbAt<0) return;
    const L=view.length?view:GAL.map((_,i)=>i), at=Math.max(0,L.indexOf(lbAt));
    openLB(L[(at+n+L.length)%L.length]);
  }
  function closeLB(){ lb.classList.remove('open'); document.body.style.overflow='';
    if(lbLast){ try{lbLast.focus()}catch(e){} lbLast=null; } }
  document.getElementById('lbClose').addEventListener('click',closeLB);
  lb.addEventListener('click',e=>{ if(e.target===lb) closeLB(); });
  addEventListener('keydown',e=>{
    if(!lb.classList.contains('open')) return;
    if(e.key==='Escape'){ closeLB(); return; }
    const n = (e.key==='ArrowRight'||e.key==='ArrowDown'||e.key==='PageDown'||e.key==='d'||e.key==='s') ? 1
            : (e.key==='ArrowLeft'||e.key==='ArrowUp'||e.key==='PageUp'||e.key==='a'||e.key==='w') ? -1 : 0;
    if(!n) return;
    e.preventDefault(); lbGo(n);
  });
  /* arrowheads either side move through the work */
  const lbPrev=document.getElementById('lbPrev'), lbNext=document.getElementById('lbNext');
  if(lbPrev) lbPrev.addEventListener('click',e=>{ e.stopPropagation(); lbGo(-1); });
  if(lbNext) lbNext.addEventListener('click',e=>{ e.stopPropagation(); lbGo(1); });
  /* swipe: the picture follows the finger sideways and snaps to the next piece;
     vertical movement is left to the page so it never fights the scroll */
  let lsw=null;
  lb.addEventListener('touchstart',e=>{
    if(e.touches.length!==1){ lsw=null; return; }
    lsw={x:e.touches[0].clientX,y:e.touches[0].clientY,t:Date.now(),dx:0,lock:null};
    lbMedia.classList.remove('snap'); lbMedia.classList.add('drag');
  },{passive:true});
  lb.addEventListener('touchmove',e=>{
    if(!lsw) return;
    const t=e.touches[0], dx=t.clientX-lsw.x, dy=t.clientY-lsw.y;
    if(!lsw.lock){ if(Math.abs(dx)<6 && Math.abs(dy)<6) return; lsw.lock=Math.abs(dx)>Math.abs(dy)?'x':'y'; }
    if(lsw.lock!=='x') return;
    lsw.dx=dx;
    lbMedia.style.transform='translateX('+dx+'px)';
    lbMedia.style.opacity=String(Math.max(.35, 1-Math.abs(dx)/(lbMedia.clientWidth||320)));
  },{passive:true});
  function lbSettle(){ lbMedia.classList.remove('drag'); lbMedia.classList.add('snap'); lbMedia.style.transform=''; lbMedia.style.opacity=''; }
  lb.addEventListener('touchend',()=>{
    if(!lsw) return;
    const dx=lsw.dx, dt=Date.now()-lsw.t, W=lbMedia.clientWidth||320, lock=lsw.lock; lsw=null;
    if(lock!=='x' || (Math.abs(dx)<W*0.22 && !(Math.abs(dx)>30 && dt<260))){ lbSettle(); return; }
    const dir=dx<0?1:-1;
    /* slide the current one out, bring the next one in from the other side */
    lbMedia.classList.add('snap'); lbMedia.style.transform='translateX('+(-dir*W)+'px)'; lbMedia.style.opacity='0';
    setTimeout(()=>{ lbGo(dir); lbMedia.classList.remove('snap'); lbMedia.classList.add('drag'); lbMedia.style.transform='translateX('+(dir*W*0.6)+'px)'; lbMedia.style.opacity='0';
      requestAnimationFrame(()=>requestAnimationFrame(lbSettle)); }, 180);
  },{passive:true});
  lb.addEventListener('touchcancel',()=>{ lsw=null; lbSettle(); },{passive:true});

})();





/* hero video: keep it running, fall back to the poster frame if blocked */
(function(){
  const v = document.getElementById('heroVid');
  if(!v) return;
  const go = ()=> v.play().catch(()=>{});
  go();
  ['loadeddata','canplay'].forEach(e=> v.addEventListener(e, go, {once:true}));
  document.addEventListener('visibilitychange', ()=>{ if(!document.hidden) go(); });
  addEventListener('click', go, {once:true});
  v.addEventListener('error', ()=>{
    v.style.display='none';
    const w = v.parentElement;
    w.style.background = 'url("'+v.poster+'") center 46%/cover no-repeat';
  });
})();


/* hero sound — iOS-style toggle */
(function(){
  const v = document.getElementById('heroVid');
  const btn = document.getElementById('snd');
  const lbl = document.getElementById('sndLbl');
  if(!v || !btn) return;

  /* music laid over the ride: window.__HERO_TRACK__ = {src, start, credit} — assets/hero-music.mp3 by default.
     The ride's own sound is ducked underneath so the two read as one mix. */
  const T = window.__HERO_TRACK__ && (window.__HERO_TRACK__.src || window.__HERO_TRACK__.yt) ? window.__HERO_TRACK__
    : { src: (window.__CDN__ || 'assets/') + 'hero-music.mp3', volume: 75, credit: '' };
  /* iOS/Android: <audio>.volume is read-only (always 1) and play() must happen inside the tap — no fades there */
  const NOVOL = (()=>{ try { const a = new Audio(); a.volume = 0.5; return a.volume !== 0.5 || /iPhone|iPad|iPod/.test(navigator.userAgent) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent)); } catch(e){ return true; } })();
  const credit = document.getElementById('sndCredit');
  const ytBox = document.getElementById('ytHero');
  let music = null;
  const RIDE_LVL = T.src ? 0 : 0.28, MUSIC_LVL = Math.max(0.1, Math.min(1, (+T?.volume || 75) / 100));
  function ytId(u){ const m = String(u||'').match(/(?:v=|\/embed\/|\/shorts\/|youtu\.be\/|\/live\/)([\w-]{11})/) || String(u||'').match(/^([\w-]{11})$/); return m ? m[1] : null; }
  /* YouTube player wrapped to look like an <audio>: .volume / .play() / .pause() / .currentTime */
  function ytTrack(){
    const id = ytId(T.yt); if(!id || !ytBox) return null;
    const from = +T.start || 0;
    const w = { _v: 0, _p: null, _ready: false, _wantPlay: false, get volume(){ return this._v; }, set volume(x){ this._v = x; if(this._p && this._ready) this._p.setVolume(Math.round(x*100)); },
      get currentTime(){ return this._p && this._ready ? this._p.getCurrentTime() : 0; }, set currentTime(t){ if(this._p && this._ready) this._p.seekTo(t, true); },
      play(){ this._wantPlay = true; if(this._p && this._ready){ this._p.playVideo(); } return Promise.resolve(); },
      pause(){ this._wantPlay = false; if(this._p && this._ready) this._p.pauseVideo(); } };
    const make = ()=>{
      w._p = new YT.Player(ytBox, { videoId: id, playerVars: { start: from, autoplay: 0, controls: 0, disablekb: 1, fs: 0, rel: 0, playsinline: 1, modestbranding: 1, iv_load_policy: 3, origin: location.origin },
        events: { onReady(){ w._ready = true; w._p.setVolume(Math.round(w._v*100)); if(w._wantPlay){ w._p.seekTo(from, true); w._p.playVideo(); } },
                  onStateChange(e){ if(e.data === YT.PlayerState.ENDED){ w._p.seekTo(from, true); w._p.playVideo(); } } } });
    };
    if(window.YT && window.YT.Player) make();
    else { const prev = window.onYouTubeIframeAPIReady; window.onYouTubeIframeAPIReady = ()=>{ prev && prev(); make(); };
      if(!document.querySelector('script[src*="youtube.com/iframe_api"]')){ const s = document.createElement('script'); s.src = 'https://www.youtube.com/iframe_api'; document.head.appendChild(s); } }
    return w;
  }

  function track(){
    if(music || !T) return music;
    if(T.yt){ music = ytTrack(); return music; }
    music = new Audio(T.src); music.preload = 'auto'; music.volume = NOVOL ? MUSIC_LVL : 0;
    const from = +T.start || 0;
    music.addEventListener('loadedmetadata', ()=>{ music.currentTime = from; });
    music.addEventListener('ended', ()=>{ music.currentTime = from; music.play().catch(()=>{}); });
    return music;
  }

  let fade = null, mfade = null;
  function rampEl(el, to, ms, holder){
    clearInterval(holder.id);
    const from = el.volume, t0 = performance.now();
    holder.id = setInterval(()=>{
      const k = Math.min(1,(performance.now()-t0)/ms);
      el.volume = Math.max(0, Math.min(1, from + (to-from)*k));
      if(k>=1){ clearInterval(holder.id); holder.id = null; }
    }, 25);
  }
  const H1 = {id:null}, H2 = {id:null};
  function ramp(to, ms){ rampEl(v, to ? RIDE_LVL : 0, ms, H1); if(music && !NOVOL) rampEl(music, to ? MUSIC_LVL : 0, ms*1.6, H2); }

  /* Asked for: the video is never touched — the song is cued to it. The arrow leaves
     the bow ~0.8s into the 4.75s ride loop; the song's first accent is at 5.2s. When the switch
     goes on, the song starts from the point that puts that accent on the next arrow release.
     Loop lengths differ, so on every ride restart the song is nudged (tiny rate change, no jumps)
     to keep the nearest accent landing on the release. */
  const RELEASE = (T && T.release) || 0.8, HITS = (T && T.hits) || [16.0];
  let syncRaf = 0, lastLoop = -1;
  function cueStart(){ const D = v.duration || 4.75, untilRelease = ((RELEASE - v.currentTime) % D + D) % D; /* the release after next, so the song has a run-up */ return Math.max(0, HITS[0] - untilRelease - D); }
  function syncRide(){
    if(!music || music.paused || !(T.src)){ syncRaf = 0; return; }
    const vt = v.currentTime, loopNo = Math.floor((performance.now()) / 100);
    if(vt < 0.12 && loopNo !== lastLoop){ lastLoop = loopNo;
      const toRelease = RELEASE - vt, want = music.currentTime + toRelease;
      const L = music.duration || 16.4, cand = HITS.concat(HITS.map(h => h + L), HITS.map(h => h - L)); let near = HITS[0], best = 1e9; for(const h of cand){ const d = Math.abs(h - want); if(d < best){ best = d; near = h; } }
      const err = near - want; /* +: song behind, speed up a touch */
      if(Math.abs(err) > 0.03 && Math.abs(err) < 1.2 && 'playbackRate' in music) music.playbackRate = Math.min(1.12, Math.max(0.9, 1 + err / Math.max(1, toRelease + 1.5)));
      else if(Math.abs(err) >= 1.2) music.playbackRate = 1;
      setTimeout(()=>{ if(music) music.playbackRate = 1; }, 900);
    }
    syncRaf = requestAnimationFrame(syncRide);
  }
  let isOn = false;
  function on(){
    isOn = true;
    /* phones can't lower the video's volume — keep the ride muted so only the song plays */
    v.muted = NOVOL && T.src ? true : false;
    v.volume = 0;
    btn.classList.add('on','used');
    btn.setAttribute('aria-pressed','true');
    lbl.textContent = 'Sound on';
    const m = track();
    if(m){ const seek = ()=>{ try { if(T.src && !T.start) m.currentTime = cueStart(); else if(m.currentTime < (+T.start||0)) m.currentTime = +T.start||0; } catch(e){} }; if(m.readyState >= 1) seek(); else m.addEventListener('loadedmetadata', seek, { once: true }); m.play().catch(()=>{}); if(credit && T.credit){ credit.textContent = T.credit; credit.classList.add('show'); } if(ytBox && T.yt) ytBox.classList.add('show'); }
    ramp(1, 650);
    if(!syncRaf && T.src) syncRaf = requestAnimationFrame(syncRide);
    const p = v.play();
    if(p && p.catch) p.catch(()=>{
      lbl.textContent = 'Blocked';
      btn.classList.remove('on');
      btn.setAttribute('aria-pressed','false');
    });
  }
  function off(){
    isOn = false;
    cancelAnimationFrame(syncRaf); syncRaf = 0; lastLoop = -1; if(music && 'playbackRate' in music) music.playbackRate = 1;
    ramp(0, 300);
    if(NOVOL && music) music.pause(); setTimeout(()=>{ v.muted = true; if(music) music.pause(); }, 500);
    btn.classList.remove('on');
    btn.classList.add('used');
    btn.setAttribute('aria-pressed','false');
    lbl.textContent = 'Sound off';
    if(credit) credit.classList.remove('show');
    if(ytBox) ytBox.classList.remove('show');
  }

  btn.addEventListener('click', e=>{
    e.preventDefault(); e.stopPropagation();
    isOn ? off() : on();
  });

  new IntersectionObserver(es=>{
    es.forEach(e=>{
      if(!isOn) return;
      if(NOVOL && music){ if(e.isIntersecting) music.play().catch(()=>{}); else music.pause(); }
      ramp(e.isIntersecting ? 1 : 0, 450);
    });
  },{threshold:0.2}).observe(document.getElementById('top'));
})();

/* About film — sound toggle */
(function(){
  const v=document.getElementById('samVid');
  const b=document.getElementById('sndSam');
  const l=document.getElementById('sndSamLbl');
  if(!v||!b) return;
  let fade=null;
  function ramp(to,ms){
    clearInterval(fade);
    const from=v.volume,t0=performance.now();
    fade=setInterval(()=>{
      const k=Math.min(1,(performance.now()-t0)/ms);
      v.volume=from+(to-from)*k;
      if(k>=1){clearInterval(fade);fade=null;}
    },25);
  }
  b.addEventListener('click',e=>{
    e.preventDefault();
    if(v.muted){
      // never let two tracks play at once
      const hero=document.getElementById('heroVid'), hsw=document.getElementById('snd');
      if(hero && (!hero.muted || (hsw && hsw.classList.contains('on')))){
        const hb0=document.getElementById('snd'); if(hb0){ hb0.click(); } else hero.muted=true;
        const hb=document.getElementById('snd');
        if(hb){ hb.classList.remove('on'); hb.setAttribute('aria-pressed','false');
                const hl=document.getElementById('sndLbl'); if(hl) hl.textContent='Sound off'; }
      }
      v.muted=false; v.volume=0;
      b.classList.add('on','used'); b.setAttribute('aria-pressed','true'); l.textContent='Film sound on';
      ramp(0.85,600);
      const p=v.play();
      if(p&&p.catch) p.catch(()=>{ l.textContent='Blocked'; b.classList.remove('on'); });
    } else {
      ramp(0,280);
      setTimeout(()=>{v.muted=true;},300);
      b.classList.remove('on'); b.classList.add('used');
      b.setAttribute('aria-pressed','false'); l.textContent='Film sound';
    }
  });
  new IntersectionObserver(es=>{es.forEach(e=>{
    if(v.muted) return;
    ramp(e.isIntersecting?0.85:0,420);
  })},{threshold:0.3}).observe(v);
})();


/* ============ SHOP ============ */
(function(){
  const P = window.__SHOP__;
  const grid=document.getElementById('products'), fbar=document.getElementById('filters');
  if(!grid||!P) return;
  const cats=['All',...[...new Set(P.map(p=>p.c))]];
  cats.forEach((c,i)=>{
    const b=document.createElement('button');
    b.type='button'; b.textContent=c; b.setAttribute('aria-pressed', i===0?'true':'false');
    b.addEventListener('click',()=>{
      fbar.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed','false'));
      b.setAttribute('aria-pressed','true');
      let n=0;
      grid.querySelectorAll('.card').forEach(card=>{
        const hide = c!=='All' && card.dataset.cat!==c;
        card.classList.toggle('hide', hide); if(!hide) n++;
      });
      const note=document.querySelector('.shop-note');
      if(note) note.dataset.count=n;
    });
    fbar.appendChild(b);
  });
  P.forEach(p=>{
    const a=document.createElement('button');
    a.className='card'; a.type='button'; a.dataset.cat=p.c;
    a.setAttribute('aria-label', p.n+' — $'+p.p);
    /* product names come from Shopify, so quotes and & in a title must not
       break out of the markup they sit in */
    const esc=s=>String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;')
      .replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    a.innerHTML =
      '<span class="cfig"><img src="'+esc(p.src)+'" alt="'+esc(p.n)+' — laser engraved by Archer Laser Toronto" loading="lazy" decoding="async"></span>'
      + '<span class="cbody"><span class="crow">'
      +   '<span class="cname">'+esc(p.n)+'</span>'
      +   '<span class="cprice">$'+esc(p.p)+'</span>'
      + '</span></span>';
    /* opened by the product-view script */
    grid.appendChild(a);
  });
})();


/* ============ PRODUCT VIEW ============ */
(function(){
  const P=window.__SHOP__; if(!P) return;
  const v=document.getElementById('pview');
  if(!v){ console.warn('product view markup missing'); return; }
  const $=i=>document.getElementById(i);
  let idx=-1;

  function show(i, push){
    idx=(i+P.length)%P.length;
    const p=P[idx];
    const photos = (p.photos && p.photos.length) ? p.photos : [p.src];
    const setPhoto=(k)=>{
      $('pvImg').style.opacity=0;
      const im=new Image();
      im.onload=()=>{ $('pvImg').src=im.src; $('pvImg').style.opacity=1; };
      im.src=photos[k];
      $('pvImg').alt=p.n+' — laser engraved by Archer Laser Toronto';
      tw.querySelectorAll('button').forEach((b,z)=>b.setAttribute('aria-pressed',String(z===k)));
    };
    const tw=$('pvThumbs'); tw.innerHTML='';
    if(photos.length>1){
      photos.forEach((src,k)=>{
        const b=document.createElement('button');
        b.type='button'; b.setAttribute('aria-label','Photo '+(k+1));
        b.setAttribute('aria-pressed',String(k===0));
        const tsrc=(p.thumbs&&p.thumbs[k])?p.thumbs[k]:src;
        b.innerHTML='<img src="'+encodeURI(tsrc)+'" alt="" loading="lazy">';
        b.querySelector('img').onerror=function(){ this.onerror=null; this.src=src; };
        b.addEventListener('click',()=>setPhoto(k));
        tw.appendChild(b);
      });
    }
    setPhoto(0);
    $('pvCat').textContent=p.c; $('pvName').textContent=p.n;
    $('pvSpec').textContent=p.spec;
    const dEl=$('pvDesc'); dEl.textContent='';
    if(p.bullets && p.bullets.length){
      const ul=document.createElement('ul'); ul.className='pv-bul';
      p.bullets.forEach(b=>{ const li=document.createElement('li'); li.textContent=b; ul.appendChild(li); });
      dEl.appendChild(ul);
    } else dEl.textContent=p.d;
    $('pvPrice').textContent='$'+p.p;
    $('pvCount').textContent=(idx+1)+' / '+P.length;
    $('pvAdd').textContent='Add to cart'; $('pvAdd').classList.remove('done');
    v.classList.add('open'); document.body.style.overflow='hidden'; v.scrollTop=0;
    setTimeout(()=>{ const b=document.getElementById('pvClose'); if(b) b.focus(); },80);
    if(push!==false) history.pushState({p:idx},'', '#piece/'+p.s);
  }
  let lastFocus=null;
  function close(push){
    v.classList.remove('open'); document.body.style.overflow=''; idx=-1;
    if(lastFocus){ try{lastFocus.focus()}catch(e){} lastFocus=null; }
    if(push!==false && location.hash.indexOf('#piece/')===0) history.pushState({},'', '#shop');
  }
  document.querySelectorAll('.card').forEach((c,i)=>{
    c.addEventListener('click', e=>{ e.preventDefault(); lastFocus=c; show(i); });
  });
  $('pvBack').addEventListener('click',()=>close());
  $('pvClose').addEventListener('click',()=>close());
  $('pvPrev').addEventListener('click',()=>show(idx-1));
  $('pvNext').addEventListener('click',()=>show(idx+1));
  addEventListener('keydown',e=>{
    if(!v.classList.contains('open')) return;
    if(e.key==='Escape') close();
    if(e.key==='ArrowLeft') show(idx-1);
    if(e.key==='ArrowRight') show(idx+1);
  });
  addEventListener('popstate',e=>{
    if(e.state && typeof e.state.p==='number') show(e.state.p,false); else close(false);
  });
  if(location.hash.indexOf('#piece/')===0){
    const s=location.hash.split('/')[1];
    const i=P.findIndex(x=>x.s===s); if(i>=0) setTimeout(()=>show(i,false),60);
  }
  /* there is no floating cart button any more: the panel opens when something
     is added, and Shopify's own cart page is where an order gets reviewed */
  const btn=null, n=null, cart=$('cart');
  let lines=[];
  const CART_KEY='archer.cart.v1';
  function saveCart(){
    try{ localStorage.setItem(CART_KEY, JSON.stringify(lines.map(l=>({
      s:l.p.s, q:l.q, variant:l.variant||null,
      own: !!l.own, n:l.p.n, price:l.p.p, spec:l.p.spec||'',
      design: l.design ? {engraving:l.design.engraving, typeface:l.design.typeface,
        props:l.design.props||null} : null
    })))); }catch(e){}
    mirrorShopify();
  }

  /* This panel is the customer's cart, so Shopify's cart has to follow it on
     every change — adding, changing a quantity, removing a line — not only at
     checkout. Each mirror rewrites Shopify's cart from these lines, with the
     engraving on each line, so the two can never drift apart. Off-store (or if
     the cart API is unreachable) it does nothing and checkout reconciles. */
  let mirrorT=null, mirrorLast='';
  function mirrorShopify(){
    clearTimeout(mirrorT);
    mirrorT=setTimeout(()=>{
      const items=lines.map(l=>({
        id: l.variant||l.p.variant||null, quantity: l.q,
        properties: (l.design&&l.design.props)||undefined
      })).filter(x=>x.id);
      const sig=JSON.stringify(items);
      if(sig===mirrorLast) return;
      mirrorLast=sig;
      const post=(url,body)=>fetch(url,{method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json'},body:JSON.stringify(body)})
        .then(r=>{ if(!r.ok) throw new Error('cart'); return r; });
      post('/cart/clear.js',{})
        .then(()=>items.length ? post('/cart/add.js',{items:items}) : null)
        .catch(()=>{ mirrorLast=''; });
    }, 350);
  }
  try{
    const raw=localStorage.getItem(CART_KEY);
    if(raw){
      const saved=JSON.parse(raw);
      if(Array.isArray(saved)) lines=saved.map(l=>{
        const q=Math.max(1, parseInt(l.q,10)||1);
        if(l.own){
          /* the customer's own piece: not a catalogue item, drawn from what was saved */
          const qp=window.__QUOTE_PRODUCT__||null;
          return {p:{s:l.s, n:l.n||'Your own piece', spec:l.spec||'Engraved to your design',
                     p:l.price||0, src:'', thumbs:[], photos:[], variant:(qp&&qp.variant)||l.variant||null},
                  q:q, own:true, variant:(qp&&qp.variant)||l.variant||null, design:l.design||null};
        }
        const p=P.find(x=>x.s===l.s);
        return p ? {p:p, q:q, variant:l.variant||p.variant||null, design:l.design||null} : null;
      }).filter(Boolean);
    }
  }catch(e){}

  /* After checkout the customer comes back here. If we handed a cart to
     Shopify and Shopify's cart is now empty, the order went through — so the
     site cart empties too. If Shopify still holds the items, they abandoned
     checkout and everything stays as it was. */
  (function reconcile(){
    let pending=null;
    try{ pending=JSON.parse(localStorage.getItem('archer.checkout.pending')||'null'); }catch(e){}
    if(!pending || !(window.__SHOPIFY__||{}).store) return;
    const clearFlag=()=>{ try{ localStorage.removeItem('archer.checkout.pending'); }catch(e){} };
    if(Date.now()-(pending.at||0) > 3*24*3600*1000){ clearFlag(); return; }
    fetch('/cart.js',{credentials:'same-origin'}).then(r=>r.ok?r.json():null).then(c=>{
      if(!c) return;
      clearFlag();
      if(c.item_count===0 && lines.length){ lines=[]; renderCart(); }
    }).catch(()=>{});
  })();

  function fmt(v){ return '$'+v.toLocaleString('en-CA'); }
  /* The cart shows the piece the customer picked — its last photo, which is the
     shot with clear space for the mark. Own-piece lines show their own photo. */
  const esc=s=>String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  function cartThumb(l){
    if(l.own) return (l.design&&(l.design.piecePhoto||l.design.proof)) || l.p.src || '';
    const ph=l.p.photos, last=ph&&ph.length?ph[ph.length-1]:null;
    return last || (l.p.thumbs&&l.p.thumbs.length?l.p.thumbs[l.p.thumbs.length-1]:null)
      || l.p.src || (l.design&&(l.design.piecePhoto||l.design.proof)) || '';
  }
  function total(){ return lines.reduce((a,l)=>a+l.p.p*l.q,0); }

  function renderCart(){
    saveCart();
    const box=$('cartItems');
    if(!lines.length){
      box.innerHTML='<div class="cart-empty">Nothing in here yet.<br>Add a piece and it&#39;ll show up.</div>';
      $('cartCheckout').disabled=true;
    } else {
      box.innerHTML=lines.map((l,i)=>
        '<div class="citem">'
        + (cartThumb(l)
            ? '<img src="'+esc(cartThumb(l))+'" alt="" title="Click to zoom" data-zoom="1" loading="lazy" decoding="async">'
            : '<span class="cthumb-none" aria-hidden="true"></span>')
        + '<div class="ci"><div class="cn">'+esc(l.p.n)+'</div>'
        +   '<div class="cs">'+esc(l.p.spec)+'</div>'
        +   (l.design
              ? '<div class="cmark ok">Engraved: '+esc(l.design.engraving)+'</div>'
              : '<div class="cmark no">We\u2019ll email you to agree the engraving</div>')
        +   (l.own ? '<div class="cmark quote">'+(l.variant||l.p.variant ? 'Priced by hand after checkout' : 'Quote by email')+'</div>' : '')
        +   '<span class="qty"><button type="button" data-m="'+i+'" aria-label="One fewer">&minus;</button>'
        +   '<span>'+l.q+'</span>'
        +   '<button type="button" data-a="'+i+'" aria-label="One more">+</button></span>'
        + '</div>'
        + '<div><div class="cp">'+fmt(l.p.p*l.q)+'</div>'
        +   '<button class="rm" type="button" data-r="'+i+'">Remove</button></div>'
        + '</div>').join('');
      $('cartCheckout').disabled=false;
    }
    $('cartTotal').textContent=fmt(total());
    /* Checkout is Shopify's. A customer's own piece has nothing to sell, so the
       note tells them how it gets priced instead of pretending to charge. */
    const note=$('cartQuoteNote'), quoteLines=lines.filter(l=>!(l.variant||l.p.variant));
    const quote=quoteLines.length>0;
    if(note){
      note.style.display = quote ? 'block' : 'none';
      const a=note.querySelector('a');
      if(a){
        /* the email carries the whole layout, so nothing is retyped */
        const body=quoteLines.map(l=>{
          const pr=(l.design&&l.design.props)||{};
          return [l.p.n].concat(Object.keys(pr).map(k=>'  '+k+': '+pr[k])).join('\n');
        }).join('\n\n');
        a.href='mailto:contact@archerlaser.ca?subject='+encodeURIComponent('Quote for my own piece')
          +'&body='+encodeURIComponent('Hi Archer Laser,\n\nPlease quote engraving on my own piece:\n\n'+body+'\n\nI\u2019ll attach a photo of the piece.\n\nThanks,');
      }
    }
    const sellable=lines.some(l=>l.variant||l.p.variant);
    $('cartCheckout').disabled=!sellable;
    $('cartCheckout').textContent = sellable
      ? (quote ? 'Check out the priced pieces' : 'Checkout') : 'Nothing to check out';
    $('cartCheckout').setAttribute('data-label', $('cartCheckout').textContent);
    const count=lines.reduce((a,l)=>a+l.q,0);
    if(n) n.textContent=count;
    if(btn) btn.hidden=count===0;
    /* the nav's Cart link carries the count, so the cart can always be reopened */
    document.querySelectorAll('[data-cart-link]').forEach(a=>{ a.textContent = count ? 'Cart ('+count+')' : 'Cart'; });
    box.querySelectorAll('[data-a]').forEach(b=>b.onclick=()=>{lines[+b.dataset.a].q++;renderCart();});
    box.querySelectorAll('[data-m]').forEach(b=>b.onclick=()=>{
      const i=+b.dataset.m; lines[i].q--; if(lines[i].q<1) lines.splice(i,1); renderCart();});
    box.querySelectorAll('[data-r]').forEach(b=>b.onclick=()=>{lines.splice(+b.dataset.r,1);renderCart();});
  }

  function openCart(){ cart.classList.add('open'); cart.classList.remove('step-form','step-done');
    document.body.style.overflow='hidden'; renderCart(); }
  function closeCart(){ cart.classList.remove('open'); document.body.style.overflow=''; }

  $('pvAdd').addEventListener('click',()=>{
    const p=P[idx];
    /* an engraved line is one specific design — a plain add is its own line */
    const found=lines.find(l=>l.p.s===p.s && !l.design);
    if(found) found.q++; else lines.push({p:p,q:1});
    $('pvAdd').textContent='Added ✓'; $('pvAdd').classList.add('done');
    setTimeout(()=>{ $('pvAdd').textContent='Add to cart'; $('pvAdd').classList.remove('done'); },1400);
    renderCart(); openCart();
  });
  if(btn) btn.addEventListener('click',openCart);
  document.addEventListener('click',e=>{
    const a=e.target.closest && e.target.closest('[data-cart-link]');
    if(!a) return;
    e.preventDefault();
    const m=document.getElementById('mobmenu'), bg=document.getElementById('burger');
    if(m) m.classList.remove('open'); if(bg) bg.setAttribute('aria-expanded','false');
    openCart();
  });
  window.ArcherCart={open:openCart, close:closeCart, count:()=>lines.reduce((a,l)=>a+l.q,0)};
  $('cartClose').addEventListener('click',closeCart);
  $('cartKeep').addEventListener('click',closeCart);
  $('cartItems').addEventListener('click',e=>{
    const img=e.target.closest('img[data-zoom]');
    if(img) img.closest('.citem').classList.toggle('zoomed');
  });
  cart.addEventListener('click',e=>{ if(e.target===cart) closeCart(); });
  addEventListener('keydown',e=>{ if(e.key==='Escape'&&cart.classList.contains('open')) closeCart(); });

  renderCart();

  /* a design approved in the overlay lands here */
  addEventListener('message',ev=>{
    const d=ev.data;
    if(!d||d.type!=='archer-design') return;
    const base = P.find(x=>x.s===d.slug) || P.find(x=>d.piece && x.n===d.piece) || (window.__QUOTE_PRODUCT__ && window.__QUOTE_PRODUCT__.s===d.slug ? window.__QUOTE_PRODUCT__ : null);
    /* the engraved price the customizer sends is the price of the CHOSEN
       Engrave variant (Both sides costs more than one side), so it — not the
       product's one-side list price — is what the cart line carries */
    const unit = (d.price!=null && parseFloat(d.price)>0) ? parseFloat(d.price) : null;
    const priced = o => (unit!=null && parseFloat(o.p)!==unit) ? Object.assign({}, o, {p:unit}) : o;
    /* an own piece shows as the customer's own, whatever product carries it */
    const p0 = d.own
      ? Object.assign({}, base||{}, {s:d.slug||'own', n:d.piece||'Your own piece', spec:'Engraved to your design',
          p:d.price||0, src:(d.piecePhoto||d.proof), thumbs:[d.piecePhoto||d.proof], photos:[d.piecePhoto||d.proof],
          variant:(base&&base.variant)||d.variant||null})
      : (base || {s:d.slug||'own', n:d.piece||'Your own piece', spec:'Engraved to your design',
          p:d.price||0, src:(d.piecePhoto||d.proof), thumbs:[d.piecePhoto||d.proof], photos:[d.piecePhoto||d.proof]});
    const p = d.own ? p0 : priced(p0);
    const design={engraving:d.engraving||'—', typeface:d.typeface||'—', proof:d.proof,
                  piecePhoto:d.piecePhoto||null, props:d.props||null};
    /* "Add one" from the cart, or engraving a piece already added plain:
       the design belongs on that line, not on a duplicate */
    const waiting = !d.own && lines.find(l=>l.p.s===p.s && !l.design);
    const qty=Math.max(1, parseInt(d.qty,10)||1);
    if(waiting){ waiting.design=design; waiting.variant=d.variant||p.variant||waiting.variant||null; waiting.q=Math.max(waiting.q, qty);
      if(unit!=null) waiting.p=priced(waiting.p); }
    else lines.push({p:p, q:qty, own:!!d.own, variant:d.variant||p.variant||null, design:design});
    renderCart();
    const dz=document.getElementById('dz');
    setTimeout(()=>{
      if(dz){ dz.classList.remove('open'); }
      document.body.style.overflow='hidden';
      cart.classList.add('open'); cart.classList.remove('step-form','step-done');
      renderCart();
    },900);
  });
})();


